export const themeMixin = {
  data() {
    return {
      // 1. Explicitly default the state to true
      isDark: true 
    };
  },
  
  mounted() {
    this.initializeTheme();
  },
  
  methods: {
    initializeTheme() {
      const savedTheme = localStorage.getItem('theme');
      
      // 2. Only switch to light if the user explicitly saved 'light'
      // Otherwise, stay true to the default (Dark)
      if (savedTheme === 'light') {
        this.isDark = false;
      } else {
        this.isDark = true;
      }
      
      this.applyTheme(this.isDark);
    },
    
    applyTheme(isDark) {
      if (isDark) {
        document.body.classList.remove('light');
        document.body.classList.add('dark');
        localStorage.setItem('theme', 'dark');
      } else {
        document.body.classList.remove('dark');
        document.body.classList.add('light');
        localStorage.setItem('theme', 'light');
      }
    },
    
    toggleTheme() {
      this.isDark = !this.isDark;
      this.applyTheme(this.isDark); // Ensure immediate application
    }
  }
};